export { default } from "./WebinarCard";
